export const animationsConfig = {
  chatWrapper: {
    fullScreenModeChangeDuration: 0.3,
    circleAnimationDuration: 0.6,
  },
  gdpr: {
    appearDuration: 0.3,
    slideDistance: 20,
    shake: {
      duration: 0.4,
      intensity: 3, // pixels for each shake movement
      oscillations: 4, // number of shakes
    },
  },
} as const;
